import axios from "axios";
import { getTokenMicro } from "./msalService";
export const rotaAutenticacao = process.env.REACT_APP_ROUTE_AUTH
export const authority = "https://login.microsoftonline.com/a56222e7-2ad0-4357-81fc-8485f79f59ec"

const axiosInstance = axios.create({
  baseURL: rotaAutenticacao
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getTokenMicro();
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance
